import { useaxios } from "../../../utils/useaxios";
export default (from, to, customer_id) => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/customer_loan/loan_in.php', { from, to, customer_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setloan_in_report', payload: res.data });
            settable_type("loan_in_report");
        }
        // setloading(false);
    });
}